import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setLanguage } from '@cmsgov/ds-healthcare-gov';
import i18n from './locale/i18n';
import App from './components/App';
import { getLanguageFromHost } from './utilities/getLanguageFromHost';
import { initializeNewRelic } from './utilities/newrelic';

import '@cmsgov/ds-healthcare-gov/css/index.css';
import '@cmsgov/ds-healthcare-gov/css/healthcare-theme.css';
import './index.css';

initializeNewRelic();

const locale = getLanguageFromHost();
// set lang on <html>
document.documentElement.lang = locale;
// From design system,
// see: https://design.cms.gov/guidelines/i18n#default-internationalized-content-in-the-design-system
setLanguage(locale);

document.title = i18n.t('estimatorPageTitle');

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
